import React from 'react';
import Ticker from 'react-ticker';
import getBreakpointView from 'utils/getBreakpointView';
import { truncateText } from 'utils/text';
import { ArrowRightIcon, ArrowRightHoverIcon } from 'components/Brand/Icons';
import {
  CardsWrapperContainer,
  CardBodyContainer,
  FooterContainer,
  CategoryContainer,
} from './styles';

const CardsBodyWrapper = WrappedCard => {
  const WrappedComponents = props => {
    const { ctaTitle, hovered, align, simpleResponsive = false, type, category } = props;

    return (
      <CardsWrapperContainer>
        <CardBodyContainer
          className={`${simpleResponsive ? 'simple-responsive' : ''} ${
            ctaTitle ? 'with-footer-cta' : ''
          }`}
          align={align}
        >
          {category && <CategoryView {...{ category, hovered, simpleResponsive }} />}
          <WrappedCard
            {...props}
            {...(props.title && { title: truncateText(props.title, 70) })}
            {...(props.description && { description: truncateText(props.description, 175) })}
            {...(props.quote && { quote: truncateText(props.quote, 380) })}
          />
          {ctaTitle && <FooterButton {...{ ctaTitle, hovered, align, simpleResponsive, type }} />}
        </CardBodyContainer>
      </CardsWrapperContainer>
    );
  };

  return WrappedComponents;
};

export default CardsBodyWrapper;

const CategoryView = ({ category, hovered, simpleResponsive }) => {
  const isMobile = getBreakpointView(['xs']);

  const CategoryContent = (
    <CategoryContainer
      className={`${simpleResponsive ? 'simple-responsive' : ''} card-category`}
      hovered={hovered || isMobile}
    >
      <p>{category}</p>
    </CategoryContainer>
  );

  if (category.length > 28 && (hovered || isMobile)) {
    return (
      <Ticker mode={'await'} speed={3}>
        {() => CategoryContent}
      </Ticker>
    );
  }

  return CategoryContent;
};

const FooterButton = ({ ctaTitle, hovered, align, simpleResponsive, type }) => {
  return (
    <FooterContainer
      className={`${simpleResponsive ? 'simple-responsive' : ''} ${
        type === 'Icon' ? 'icon-card-footer' : ''
      }`}
      {...{ hovered, align }}
    >
      {ctaTitle}
      {hovered ? <ArrowRightHoverIcon /> : <ArrowRightIcon />}
    </FooterContainer>
  );
};
